module.exports = __webpack_public_path__ + "img/login-main.bc50712a.svg";